import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from '../services/common_services/common.service';
import { paths } from '../enums/paths.enum';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private location: Location,
        private commonService: CommonService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.CheckURLHit(route);
    }

    CheckURLHit(route): boolean {       
   
        const token = this.commonService.getLocalStorageitem('token');     
        // if(this.router.navigated == false){
        // if (document.referrer == null || document.referrer == '') {
        //     this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
        //     return false;
        // }}
        let DmsNo = route.queryParamMap.get('DMSNo')
        let CampId = route.queryParamMap.get('campId')
        let MobileNo = route.queryParamMap.get('Mobile')

        if(DmsNo != "" && DmsNo != null && CampId != "" && CampId != null && MobileNo != "" && MobileNo != null){
            return true;
        }

        if (token === "" || token === undefined) {
            this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
            return false;
        }
        return true;

    }
}